// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getChannelsReducer } from './getChannels';
import { reducer as setPageViewReducer } from './setPageView';
import { reducer as searchChannelsReducer } from './searchChannels';
import { reducer as searchChannelsV2Reducer } from './searchChannelsV2';
import { reducer as setNotificationReducer } from './setNotification';
import { reducer as unsetNotificationReducer } from './unsetNotification';
import { reducer as setStatusReducer } from './setStatus';
import { reducer as setSocketConnectionReducer } from './setSocketConnection';
import { reducer as setUnreadMessageReducer } from './setUnreadMessage';
import { reducer as unsetUnreadMessageReducer } from './unsetUnreadMessage';
import { reducer as getNotificationsReducer } from './getNotifications';
import { reducer as addNotificationReducer } from './addNotification';
import { reducer as setToReplyReducer } from './setToReply';
import { reducer as resetNotificationsReducer } from './resetNotifications';
import { reducer as toggleSidebarReducer } from './toggleSidebar';
import { reducer as getChannelReducer } from './getChannel';
import { reducer as getUserChannelReducer } from './getUserChannel';
import { reducer as getBroadcastsReducer } from './getBroadcasts';
import { reducer as toggleBroadcastReducer } from './toggleBroadcast';
import { reducer as getBroadcastUsersReducer } from './getBroadcastUsers';
import { reducer as createBroadcastReducer } from './createBroadcast';
import { reducer as setCurrentBroadcastReducer } from './setCurrentBroadcast';
import { reducer as deleteBroadcastReducer } from './deleteBroadcast';
import { reducer as getChannelCountReducer } from './getChannelCount';
import { reducer as getSupportGroupsReducer } from './getSupportGroups';
import { reducer as getNewUsersReducer } from './getNewUsers';
import { reducer as getRecentlyReassignedUsersReducer } from './getRecentlyReassignedUsers';
import { reducer as getUserChannelCountReducer } from './getUserChannelCount';
import { reducer as getGroupChannelCountReducer } from './getGroupChannelCount';
import { reducer as getSponsorsListReducer } from './getSponsorsList';
import { reducer as getUserFromChannelIdReducer } from './getUserFromChannelId';
import { reducer as setChannelInfoReducer } from './setChannelInfo';
import { reducer as setChannelRelationReducer } from './setChannelRelation';
import { reducer as setSidebarFilterParamsReducer } from './setSidebarFilterParams';
import { reducer as getBroadcastDetailsReducer } from './getBroadcastDetails';
import { reducer as resendFailedBroadcastReducer } from './resendFailedBroadcast';

const reducers = [
  getChannelsReducer,
  setPageViewReducer,
  searchChannelsReducer,
  searchChannelsV2Reducer,
  setNotificationReducer,
  unsetNotificationReducer,
  setStatusReducer,
  setSocketConnectionReducer,
  setUnreadMessageReducer,
  unsetUnreadMessageReducer,
  getNotificationsReducer,
  addNotificationReducer,
  setToReplyReducer,
  resetNotificationsReducer,
  toggleSidebarReducer,
  getChannelReducer,
  getUserChannelReducer,
  getBroadcastsReducer,
  toggleBroadcastReducer,
  getBroadcastUsersReducer,
  createBroadcastReducer,
  setCurrentBroadcastReducer,
  deleteBroadcastReducer,
  getChannelCountReducer,
  getSupportGroupsReducer,
  getNewUsersReducer,
  getRecentlyReassignedUsersReducer,
  getUserChannelCountReducer,
  getGroupChannelCountReducer,
  getSponsorsListReducer,
  getUserFromChannelIdReducer,
  setChannelInfoReducer,
  setChannelRelationReducer,
  setSidebarFilterParamsReducer,
  getBroadcastDetailsReducer,
  resendFailedBroadcastReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/common/redux/reducer.js